import { useCallback, useEffect, useRef, useState } from "react";
export interface IUseQueryHook<Data = unknown> {
  loading: boolean;
  data: Data | undefined;
  error: any;
  refetch: () => Promise<void>;
}

type AsyncActionType<Data> = () => Promise<Data>;

export function useQueryHook<Data = unknown>(
  action: AsyncActionType<Data>,
  doNotFetchData?: boolean[] | boolean
): IUseQueryHook<Data> {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<Data>();
  const [error, setError] = useState<any>();

  const isMounted: React.MutableRefObject<boolean> = useRef<boolean>(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    return () => {
      isMounted.current = false;
    };
  }, []);

  const actionWrapper = useCallback(async () => {
    try {
      setLoading(true);
      const data: Data = await action();
      setData(data);
    } catch (error) {
      setError(error);
      // throw error;
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  }, [action, isMounted.current]);
  // console.log(isMounted, "out");

  useEffect(() => {
    if (typeof doNotFetchData === "boolean" && doNotFetchData) {
      return;
    }

    if (typeof doNotFetchData === "object" && doNotFetchData?.includes(true)) {
      return;
    }

    actionWrapper();
  }, [doNotFetchData]);

  return {
    loading,
    data,
    error,
    refetch: actionWrapper,
  };
}
